import React, { PureComponent } from 'react';
import { parse, stringify } from 'flatted';
import cmsData from 'Lib/cmsData';
import FourOhFour from '../../components/four-oh-four';
import CaseStudyHero from '../../components/case-study/case-study-hero';
import CaseStudyContent from '../../components/case-study/case-study-content';
import CaseStudyGrid from '../../components/case-study/case-study-grid';
import withYouTubeModal from '../../components/with-youtube-modal';

class CaseStudy extends PureComponent {

  static async getInitialProps({ query }) {
    const contentParams = {
      content_type: 'partner',
      'fields.partnerSlug': query.partner,
      include: 3,
    };

    const data = await cmsData(contentParams);
    const flatData = data && data[0] ? stringify(data[0]) : null;

    return { data: flatData };
  }

  render() {
    if (!this.props.data) return <FourOhFour />;

    const data = this.props.data && parse(this.props.data);

    return (
      <main>
        <CaseStudyHero
          logo={data.fields.partnerLogoLight}
          caseStudyProjectName={data.fields.featuredProjectName}
          image={data.fields.partnerFeaturedPhoto}
          content={data.fields.caseStudyContent}
          videoLink={data.fields.videoLink}
        />
        <CaseStudyContent
          title={data.fields.impactReportTitle}
          impactDescription={data.fields.impactReportContent}
          impactReport={data.fields.impactReport}
          carouselSlides={data.fields.caseStudyGallery}
        />
        <CaseStudyGrid
          title={data.fields.relatedTitle}
          description={data.fields.relatedDescription}
          related={data.fields.relatedCaseStudies}
        />
      </main>
    );
  }
}

export default withYouTubeModal(CaseStudy);
